<template>
  <Modal :job="job">
    <template #title>{{ model.id ? 'Edit Task' : 'Add Task' }}</template>
    <Textarea
      v-model="model.description"
      @keydown="errors.description = ''"
      id="description"
      :error="errors.description"
      has-focus
      >Task</Textarea
    >
    <template #actions>
      <CloseButton @click="$modals.close()" />
      <DeleteButton v-if="showDelete" @click="deleteModel()" />
      <SaveButton @click="save()" />
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { AxiosError } from 'axios'
import { PropType } from 'vue'
import CloseButton from '~/components/CloseButton.vue'
import DeleteButton from '~/components/DeleteButton.vue'
import Modal from '~/components/Modal.vue'
import SaveButton from '~/components/SaveButton.vue'
import Textarea from '~/components/Textarea.vue'
import { useModelEdits } from '~/database'
import Job from '~/database/models/Job'
import Task from '~/database/models/Task'

const props = defineProps({
  task: {
    type: Object as PropType<Partial<Task>>,
    default: () => ({}),
  },
  resolve: {
    type: Function as PropType<Function>,
    required: true,
  },
  axiosError: {
    type: [Object, undefined] as PropType<AxiosError | undefined>,
    default: () => undefined,
  },
  bypassQueue: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  job: {
    type: [Object, undefined] as PropType<Job | undefined>,
    default: () => undefined,
  },
})

const { model, errors, showDelete, deleteModel, save } = useModelEdits<Task>(
  props.task,
  Task,
  ['description'],
  props.resolve,
  {
    axiosError: props.axiosError,
    bypassQueue: props.bypassQueue,
    deleteMessage: 'Delete this task?',
  },
)

if (props.job) {
  model.value.job_id = props.job.id
}
</script>

<style scoped></style>
